"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostHogProvider = void 0;
const react_1 = __importStar(require("react"));
const dayjs_1 = __importDefault(require("dayjs"));
const posthog_js_1 = require("posthog-js");
const PostHogContext_1 = require("./PostHogContext");
const WebVitals_1 = __importDefault(require("./WebVitals"));
const PostHogProvider = ({ apiKey, projectId, enable = false, config = {}, reportWebVitals = true, children }) => {
    const [client, setClient] = (0, react_1.useState)();
    const baseEventProps = (0, react_1.useCallback)(() => ({
        sent_at_local: (0, dayjs_1.default)().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        posthog_project_id: projectId
    }), []);
    (0, react_1.useEffect)(() => {
        const turnOn = enable && typeof apiKey === "string" && !!apiKey;
        setClient((oldClient) => {
            if (turnOn) {
                const client = oldClient !== null && oldClient !== void 0 ? oldClient : posthog_js_1.posthog.init(apiKey, Object.assign(Object.assign({ api_host: "https://eu.posthog.com", capture_pageleave: false, capture_pageview: false }, config), { sanitize_properties: (props, evt) => {
                        var _a, _b;
                        const allProps = Object.assign(Object.assign({}, baseEventProps()), props);
                        return (_b = (_a = config.sanitize_properties) === null || _a === void 0 ? void 0 : _a.call(config, allProps, evt)) !== null && _b !== void 0 ? _b : allProps;
                    } }));
                // clear localStorage state that might have been set by previous clients
                client.clear_opt_in_out_capturing();
                // we got consent, start capturing
                client.opt_in_capturing();
                // calling a private function as a fix for bug https://github.com/PostHog/posthog-js/issues/336
                client._start_queue_if_opted_in();
                return client;
            }
            else {
                oldClient === null || oldClient === void 0 ? void 0 : oldClient.opt_out_capturing();
                return undefined;
            }
        });
    }, [enable]);
    return (react_1.default.createElement(PostHogContext_1.PostHogContext.Provider, { value: client },
        reportWebVitals && react_1.default.createElement(WebVitals_1.default, null),
        children));
};
exports.PostHogProvider = PostHogProvider;
exports.default = exports.PostHogProvider;
